import { render } from "./SortableList.vue?vue&type=template&id=10753da2&scoped=true"
import script from "./SortableList.vue?vue&type=script&lang=js"
export * from "./SortableList.vue?vue&type=script&lang=js"

import "./SortableList.vue?vue&type=style&index=0&id=10753da2&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10753da2"]])

export default __exports__